function homeModalVideo() {
  const closeButton = document.querySelector(".youtube-video-close");
  const overlayVideo = document.querySelector(".overlay-home-video");
  const videoContainer = document.querySelector(".youtube-video-container");
  const triggerButton = document.querySelector(".youtube-video-trigger");
  if (!triggerButton) {
    return; // Exit if the trigger button is not found
  }

  triggerButton.addEventListener("click", () => {
    videoContainer.classList.add("active");
    overlayVideo.classList.add("active");
    const iframe = videoContainer.querySelector("iframe");

    if (iframe) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    }
  });

  if (closeButton) {
    closeButton.addEventListener("click", () => {
      videoContainer.classList.remove("active");
      overlayVideo.classList.remove("active");
      const iframe = videoContainer.querySelector("iframe");
      if (iframe) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }
    });
  }
}
export default homeModalVideo;



// WEBPACK FOOTER //
// ./src/js/partials/home-modal-video.js